import Component from 'components/pages/ScreenerSurvey/ScreenerSurvey';
import { buildPage } from 'utils/pageHelper';
export default buildPage(Component, {
  requiresAuthentication: true,
  fullPage: true,
  metaData: {
    title: 'Screener Survey',
    description: 'Tell us more about yourself so we can match you to the right surveys.',
  },
});
